const electricity_contract = `You: Hi, I want to set up a new electricity contract. What options do you have?
Representative: Sure, we offer fixed and flexible contracts. Fixed locks in a rate, while flexible varies with market conditions.
You: What are the prices? Any penalties for breaking a fixed term?
Representative: Fixed is $0.12 per kWh. Yes, there might be a fee for early termination. Want more details?
You: Got it. How does the basic price compare? Does apartment size matter?
Representative: Basic price is the same. Apartment size affects total consumption. We can tailor a plan based on your needs.
You: Cool. Tell me about flexible contract pricing.
Representative: Flexible rates vary based on market conditions. We provide real-time updates for you to take advantage of lower rates.
You: When should the contract start? Can I choose a date?
Representative: We can accommodate your preferred start date. Best to finalize details a few weeks before your current contract ends.
You: One more thing. Can we negotiate the price?
Representative: Absolutely, we can discuss. What rate have you found elsewhere?
You: Found $0.11 per kWh. Can you match or come close?
Representative: Let me check. I found $0.115 per kWh. Close enough for you?
You: Sounds good. Let's finalize with that rate.
Representative: Great! I'll prepare the paperwork. Any other questions?
You: Nope, thanks for your help.
Representative: You're welcome! If you need anything, just let us know. Have a great day!`;
export default electricity_contract;